export default "__VITE_ASSET__CjSCXGsF__"